module.exports = __webpack_public_path__ + "b78bf94083155edc3096e7820ea075f7.svg";